import { useEffect } from "react";

/** Freeze page scroll while an overlay is open (modal, drawer, palette).
 *  The page never reflows: `html { scrollbar-gutter: stable }` (v2-tokens.css)
 *  keeps the scrollbar's space reserved while overflow is hidden. Restores
 *  whatever it found on close or unmount, so stacked overlays each hand back
 *  the previous value. One hook for every modal in the app. */
export function useScrollLock(active = true) {
  useEffect(() => {
    if (!active) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [active]);
}
